import { forwardRef, MutableRefObject } from 'react'
import cx from 'classnames'
import { Link } from 'features/i18n/router'
import { useTranslation } from 'react-i18next'

// todo: every button should use this component
const Button = forwardRef(
  (
    {
      children,
      icon,
      desktopOnly,
      bold,
      buttonStyle = 'primary',
      fluid,
      loading,
      disabled,
      onClick = () => {},
      className,
      size,
      to,
      ...props
    }: ButtonProps,
    ref: MutableRefObject<HTMLButtonElement>
  ) => {
    const Elm = to ? Link : 'button'

    const { t } = useTranslation()

    return (
      <Elm
        className={cx('Button', {
          'Button--desktop-only': desktopOnly,
          [`Button--icon-${icon}`]: icon,
          'Button--bold': bold,
          [`Button--${buttonStyle}`]: buttonStyle,
          'Button--fullwidth': fluid,
          'Button--loading': loading,
          [`Button--size-${size}`]: size,
          'Button--icon-only': !children && !!icon,
          [className]: className,
        })}
        onClick={onClick}
        disabled={loading || disabled}
        to={to}
        ref={ref}
        {...props}
      >
        {loading ? t('common.loading') : children}
      </Elm>
    )
  }
)

export type ButtonProps = {
  children?: any
  icon?:
    | 'lock-gray'
    | 'search'
    | 'edit'
    | 'empl'
    | 'clean'
    | 'gift'
    | 'gift-simple'
    | 'lock-brown'
    | 'plus'
    | 'plus-large'
    | 'plus-brown'
    | 'plus-primary'
    | 'chat-orange'
    | 'chat-pink'
    | 'chat'
    | 'chat-send'
    | 'x'
    | 'check'
    | 'check-primary'
    | 'check-green'
    | 'login'
    | 'clock'
    | 'letter-white'
    | 'letter-pink'
    | 'ellipsis'
    | 'ellipsis-with-text'
    | 'video-call'
    | 'voice-call'
    | 'create-post'
    | 'create-group'
    | 'create-thread'
    | 'account-add'
    | 'account-transfer'
    | 'minus'
    | 'minus-large'
    | 'eye'
    | 'user-muted'
    | 'carat-right'
  bold?: boolean
  buttonStyle?:
    | 'primary'
    | 'secondary'
    | 'white'
    | 'line'
    | 'twitter'
    | 'green'
    | 'blue'
    | 'red'
    | 'black'
    | 'gray'
    | 'orange'
    | 'bordered-red'
    | 'bordered-green'
    | 'bordered-gray'
    | 'bordered-gray-light'
    | 'bordered-gray-without-bg'
    | 'bordered-gray-without-bg-dark-text'
    | 'bordered-primary-without-bg'
    | 'bordered-secondary-without-bg'
    | 'bordered-white'
    | 'ghost'
    | 'ghost-red'
    | 'text'
    | 'error-text'
    | 'none'
  fluid?: boolean
  desktopOnly?: boolean
  loading?: boolean
  disabled?: boolean
  onClick?: React.MouseEventHandler
  className?: string
  size?: 'small' | 'medium' | 'large' | 'x-large'
  to?: string
  href?: string
  type?: 'button' | 'submit' | 'reset'
}

export default Button
